import React, { createContext, useState, useContext } from 'react';

const PlotDataContext = createContext({
  umapData: null,
  dotplotData: null,
  violinData: null,
  matplotData: null,
  tableData: null,
  loadingStates: [], // Initial state for loading indicators of progressive images
  receivedImages: [],          // Added
  loadingImages: false,        // Added
  setUmapData: () => {},
  setDotplotData: () => {},
  setViolinData: () => {},
  setMatplotData: () => {},
  setTableData: () => {},
  setLoadingStates: () => {}, // Setter for loading states
  setReceivedImages: () => {}, // Added
  setLoadingImages: () => {},  // Added
});

export const PlotDataProvider = ({ children }) => {
  const [umapData, setUmapData] = useState(null);
  const [dotplotData, setDotplotData] = useState(null);
  const [violinData, setViolinData] = useState(null);
  const [matplotData, setMatplotData] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [loadingStates, setLoadingStates] = useState([]); // Added state for loading states
  // Add state for receivedImages and loadingImages here
  const [receivedImages, setReceivedImages] = useState([]);    // Added
  const [loadingImages, setLoadingImages] = useState(false); // Added

  return (
    <PlotDataContext.Provider value={{
      umapData,
      setUmapData,
      dotplotData,
      setDotplotData,
      violinData,
      setViolinData,
      matplotData,
      setMatplotData,
      tableData,
      setTableData,
      loadingStates, // Provide loadingStates in context
      setLoadingStates, // Provide setLoadingStates in context
      // Provide new state and setters in context value
      receivedImages,          // Added
      setReceivedImages,       // Added
      loadingImages,           // Added
      setLoadingImages,        // Added

    }}>
      {children}
    </PlotDataContext.Provider>
  );
};

export const usePlotData = () => useContext(PlotDataContext);
